import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { authAtom } from "../recoil/atoms";
import { useMutation } from "react-query";
import { login } from "../api/auth";
import client from "../api/client";
import jwtDecode from "jwt-decode";

export const KAKAO_LOGIN_LOGO =
  process.env.PUBLIC_URL +
  "/icons/kakaotalkIcon/kakaotalk_sharing_btn_small_ov.png";

export const LOGIN_LOGO_SRC =
  process.env.PUBLIC_URL + "/pushNotification/icon_256_transparent.png";

export const KAKAO_LOGIN_BUTTON =
  process.env.PUBLIC_URL + "/kakaoLogin/ko/kakao_login_medium_wide.png";

// 로그인 훅
export const useLogin = () => {
  const navigate = useNavigate();

  const setAuthAtom = useSetRecoilState(authAtom);

  const onError = ({
    response: {
      status,
      data: { message },
    },
  }) => {
    // 에러 발생 시 로직(status가 200 이 아닐때 이곳으로옴)
    if (status === 400) {
      alert(message);
    }
  };
  const onSuccess = ({ data: { accessToken } }) => {
    setAuthAtom({
      isLoggedIn: true,
      username: jwtDecode(accessToken).user.username,
      name: jwtDecode(accessToken).user.name,
    });
    client.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
    navigate("/");
  };
  return useMutation(login, {
    onError,
    onSuccess,
  });
};
